// Componente genérico
import { useEffect } from 'react';
// Componente genérico
const features = [
    { img: require('../global/img/encarte.png'), alt: "Icone celular com mapa. Encartes do dia", label: "ENCARTES DO DIA" },
    { img: require('./img/4.png'), alt: "Icone folhetos. Mural de ofertas", label: "MURAL DE OFERTAS" },
    { img: require('../global/img/lista.png'), alt: "Icone caderneta. Lista inteligente", label: "LISTA INTELIGENTE" },
    { img: require('../global/img/mapa.png'), alt: "Icone mapa. Mapa das ofertas", label: "MAPA DAS OFERTAS" },
    { img: require('../global/img/geo.png'), alt: "Icone celular com mapa. Encartes do dia", label: "GEOLOCALIZAÇÃO" },
    { img: require('../global/img/9.png'), alt: "Icone etiqueta com desconto. Jogos e benefícios", label: "JOGOS E BENEFÍCIOS" },
];

const MakeTooMeFeature = ({ onClick, imgSrc, alt, label }) => {
    return (
        <div className='mouse-hover-option'>
            <button onClick={onClick} className="btn-oferece">
                <img src={imgSrc} alt={alt} loading="lazy" />
                <b>{label}</b>
            </button>
        </div>
    );
}
export const ViewTooMeFeatures = ({
    featuresPopup,
    setFeaturesPopup,
    iframeEncartesPopupRef
}) => {
    useEffect(() => {
        document.querySelector("html").style.overflow = featuresPopup !== -1 ? "hidden" : "auto";
    }, [featuresPopup]);

    return features.map((opt, i) => (
        <MakeTooMeFeature
            key={i}
            onClick={() => {
                if (i === 0)
                    iframeEncartesPopupRef?.current?.open()
                setFeaturesPopup(i)
            }}
            imgSrc={opt.img}
            alt={opt.alt}
            label={opt.label}
        />
    ))
}
